
<c-card-iterator
    label           = "Index"
    :items          = "assessments"
    :pagination-on  = "true"
    :item-height    = "155"
    :height         = "795"
>
    <template v-slot:card="{ item }">
        <c-assessment-card
            :item        = "item"
            :background  = "background(selected, item)"
            @selected    = "onSelected"
        />
    </template>
</c-card-iterator>
